import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useBuyerContext() {
  const { buyers } = useContext<GlobalContextType>(GlobalContext);
  return buyers;
}
